<div class="sentiment-summary-generator">
  <h3 class="sentiment-summary-generator__title">Summary generator</h3>

  <label class="sentiment-summary-generator__checkbox-wrap" *ngIf="showOnlyActionableFilter">
    <input
      type="checkbox"
      class="sentiment-summary-generator__checkbox"
      [checked]="onlyActionable"
      (change)="onOnlyActionableChange($any($event.target).checked)"
    />
    <span>Only actionable feedback</span>
  </label>

  <div class="sentiment-summary-generator__filters">
    <div class="sentiment-summary-generator__filter-group">
      <label class="sentiment-summary-generator__filter-label">Select sentiment</label>
      <select
        class="sentiment-summary-generator__select"
        [ngModel]="selectedSentiment"
        (ngModelChange)="onSentimentChange($event)"
      >
        <option value="">Sentiment</option>
        <option *ngFor="let opt of sentimentOptions" [value]="opt.value">{{ opt.label }}</option>
      </select>
    </div>
    <div class="sentiment-summary-generator__filter-group">
      <label class="sentiment-summary-generator__filter-label">Select theme</label>
      <select
        class="sentiment-summary-generator__select"
        [ngModel]="selectedThemeId"
        (ngModelChange)="onThemeChange($event)"
      >
        <option value="">Theme</option>
        <option *ngFor="let t of themes; trackBy: themeTrackBy" [value]="themeIdStr(t.themeId)">{{ t.themeName }}</option>
      </select>
    </div>
  </div>

  <div class="sentiment-summary-generator__actions">
    <button
      type="button"
      class="sentiment-summary-generator__generate"
      [disabled]="generating || !selectedSentiment || !selectedThemeId"
      (click)="generate.emit()"
    >
      {{ generating ? 'Generating...' : 'Generate' }}
    </button>
  </div>

  <div class="sentiment-summary-generator__loading" *ngIf="loadingSummary">
    <div class="sentiment-summary-generator__loading-spinner"></div>
    <span>Loading summary...</span>
  </div>
  <div class="sentiment-summary-generator__result" *ngIf="!loadingSummary && summaryText !== null && summaryText !== undefined">
    <div class="sentiment-summary-generator__result-meta" *ngIf="summaryStats">
      <span class="sentiment-summary-generator__stat-pill">
        <span class="sentiment-summary-generator__stat-pill-label">Feedback</span>
        <span class="sentiment-summary-generator__stat-pill-value">{{ summaryStats.feedbackCount }}</span>
      </span>
      <span class="sentiment-summary-generator__stat-pill sentiment-summary-generator__stat-pill--accent">
        <span class="sentiment-summary-generator__stat-pill-label">Actionable</span>
        <span class="sentiment-summary-generator__stat-pill-value">{{ summaryStats.actionableCount }}</span>
      </span>
    </div>

    <div class="sentiment-summary-generator__result-body">
      <section class="sentiment-summary-generator__section" *ngIf="summaryText">
        <div class="sentiment-summary-generator__section-head">
          <span class="sentiment-summary-generator__section-marker" aria-hidden="true"></span>
          <h4 class="sentiment-summary-generator__section-title">Summary</h4>
        </div>
        <div class="sentiment-summary-generator__summary-panel">
          <p
            *ngFor="let para of summaryParagraphs(summaryText); trackBy: paraTrackBy"
            class="sentiment-summary-generator__summary-para"
          >
            {{ para }}
          </p>
        </div>
      </section>

      <section class="sentiment-summary-generator__section" *ngIf="summaryTopIssues.length">
        <div class="sentiment-summary-generator__section-head">
          <span class="sentiment-summary-generator__section-marker" aria-hidden="true"></span>
          <h4 class="sentiment-summary-generator__section-title">Top issues</h4>
        </div>
        <ol class="sentiment-summary-generator__result-list sentiment-summary-generator__result-list--issues">
          <li *ngFor="let issue of summaryTopIssues">{{ formatTopIssueLine(issue) }}</li>
        </ol>
      </section>

      <section class="sentiment-summary-generator__section" *ngIf="summaryActionableInsights.length">
        <div class="sentiment-summary-generator__section-head">
          <span class="sentiment-summary-generator__section-marker" aria-hidden="true"></span>
          <h4 class="sentiment-summary-generator__section-title">Actionable insight</h4>
        </div>
        <ol class="sentiment-summary-generator__result-list sentiment-summary-generator__result-list--steps">
          <li *ngFor="let line of summaryActionableInsights; trackBy: insightTrackBy">{{ line }}</li>
        </ol>
      </section>

      <section class="sentiment-summary-generator__section" *ngIf="summaryNextSteps.length">
        <div class="sentiment-summary-generator__section-head">
          <span class="sentiment-summary-generator__section-marker" aria-hidden="true"></span>
          <h4 class="sentiment-summary-generator__section-title">Next steps</h4>
        </div>
        <ol class="sentiment-summary-generator__result-list sentiment-summary-generator__result-list--steps">
          <li *ngFor="let step of summaryNextSteps">{{ step }}</li>
        </ol>
      </section>
    </div>
  </div>
  <p class="sentiment-summary-generator__hint" *ngIf="!loadingSummary && (summaryText == null || summaryText === undefined) && !generating">
    Select sentiment and theme, then click "Generate" to create an AI-powered summary.
  </p>
</div>
